import { optionsState$ } from '../../additionServicesOptionsContext';
import {
  serviceCacheContext$,
  serviceContext$,
  serviceFilterAndOrderContext$,
  servicePropertyValueCacheContext$,
} from '../../bus';
import { DefaultAdditionServicesState } from '../../bus/DefaultAdditionServicesState';
import { DefaultServiceCacheState } from '../../bus/DefaultServiceCacheState';
import { DefaultServiceFilterAndOrderState } from '../../bus/DefaultServiceFilterAndOrderState';
import { DefaultServicePropertyCacheState } from '../../bus/DefaultServicePropertyCacheState';
import { DefaultServiceOptionsState } from '../../DefaultServiceOptionsState';
import { ServiceData, SetUpServiceData } from '../basket/types';
import serviceRestoreStateGenerator from './serviceRestoreStateGenerator';

/**
 * restoreAdditionalServiceFromStorageState выполняет синхронное восставновление услуг
 * на основе переданных услуг содержащих установочную услугу, формирует новый контекст услуг,
 * задает контекст фильтров и кэша.
 *
 * @param setUpServiceData
 * @param otherServices
 * @param langID
 * @param currencyID
 */
export const restoreAdditionalServiceFromStorageState = async (
  setUpServiceData: SetUpServiceData,
  otherServices: ServiceData[],
  langID: string,
  currencyID: string
) => {
  const {
    additionalServiceState,
    optionsState,
    serviceCacheState,
    servicePropertyCacheState,
    servicePropertyFilterAndOrderState,
  } = await serviceRestoreStateGenerator().Restore(
    setUpServiceData,
    [setUpServiceData, ...otherServices],
    {
      ...new DefaultAdditionServicesState(),
      CurrencyID: currencyID,
      LanguageID: langID,
    },
    {
      ...new DefaultServiceOptionsState(),
      LangID: langID,
    },
    {
      ...new DefaultServiceCacheState(),
    },
    {
      ...new DefaultServicePropertyCacheState(),
      LangID: langID,
    },
    { ...new DefaultServiceFilterAndOrderState() },
    { stopBeforeServiceCalculation: true }
  );

  serviceContext$.next(additionalServiceState);
  optionsState$.next(optionsState);
  serviceCacheContext$.next(serviceCacheState);
  servicePropertyValueCacheContext$.next(servicePropertyCacheState);
  serviceFilterAndOrderContext$.next(servicePropertyFilterAndOrderState);
};
